import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

// PrimeNG imports
import { CardModule } from 'primeng/card';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    CardModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    MessageModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  // Define individual form controls
  emailControl = new FormControl('', [Validators.required, Validators.email]);
  passwordControl = new FormControl('', [Validators.required, Validators.minLength(6)]);
  
  // Create form group using the individual controls
  loginForm = new FormGroup({
    email: this.emailControl,
    password: this.passwordControl
  });

  constructor(private translateService: TranslateService) {}

  onSubmit(): void {
    if (this.loginForm.valid) {
      // TODO: Implement login logic
      console.log('Form submitted:', this.loginForm.value);
    } else {
      // Mark all fields as touched to show validation errors
      this.markFormGroupTouched();
    }
  }

  getEmailErrorMessage(): string {
    if (this.emailControl.errors?.['required']) {
      return this.translateService.instant('login.errors.emailRequired');
    }
    if (this.emailControl.errors?.['email']) {
      return this.translateService.instant('login.errors.emailInvalid');
    }
    return '';
  }

  getPasswordErrorMessage(): string {
    if (this.passwordControl.errors?.['required']) {
      return this.translateService.instant('login.errors.passwordRequired');
    }
    if (this.passwordControl.errors?.['minlength']) {
      return this.translateService.instant('login.errors.passwordMinLength');
    }
    return '';
  }

  private markFormGroupTouched(): void {
    this.emailControl.markAsTouched();
    this.passwordControl.markAsTouched();
  }
}